// utils/localStorage.js
class LocalStorageManager {
    constructor() {
      this.listeners = []
    }
  
    setItem(key, value) {
      const oldValue = localStorage.getItem(key)
      localStorage.setItem(key, value)
      this.notifyListeners(key, value, oldValue)
    }
  
    getItem(key) {
      return localStorage.getItem(key)
    }
  
    removeItem(key) {
      const oldValue = localStorage.getItem(key)
      localStorage.removeItem(key)
      this.notifyListeners(key, null, oldValue)
    }
  
    addEventListener(callback) {
      this.listeners.push(callback)
    }
  
    removeEventListener(callback) {
      this.listeners = this.listeners.filter(listener => listener !== callback)
    }
  
    notifyListeners(key, newValue, oldValue) {
      this.listeners.forEach(callback => {
        callback({ key, newValue, oldValue })
      })
    }
  }
  
  export const localStorageManager = new LocalStorageManager()